import React, { useContext } from 'react';
import { Route, Routes, ScrollToTop } from '@thd-olt-component-react/router';
import { ExperienceContext, useConfigService } from '@thd-nucleus/experience-context';
import { string, number } from 'prop-types';
import { AppContext } from '@thd-nucleus/app-render';
import { Error } from './pages';
import { getRoutes } from './routes';
import './styles/app.scss';

export const App = ({
  pipTimeout,
  prefetchPip,
  productPodHoverDelay
}) => {
  const isPepRouteEnabled = useConfigService('fs:isPepRouteEnabled');
  const { instance } = useContext(AppContext);
  const { currentRouteName, currentRouteComponent } = instance.router;
  const routes = getRoutes(currentRouteName, currentRouteComponent, isPepRouteEnabled);
  const { channel } = useContext(ExperienceContext);

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route
          path={routes.browse.path}
          element={channel === 'mobile'
            ? (
              <routes.browseMobile.component
                pageType="browse"
                prefetchPip={prefetchPip}
                productPodHoverDelay={productPodHoverDelay}
              />
            )
            : (
              <routes.browse.component
                pageType="browse"
                prefetchPip={prefetchPip}
                productPodHoverDelay={productPodHoverDelay}
              />
            )}
        />
        <Route
          path={routes.search.path}
          element={channel === 'mobile'
            ? (
              <routes.searchMobile.component
                pageType="search"
                prefetchPip={prefetchPip}
                productPodHoverDelay={productPodHoverDelay}
              />
            )
            : (
              <routes.search.component
                pageType="search"
                prefetchPip={prefetchPip}
                productPodHoverDelay={productPodHoverDelay}
              />
            )}
        />
        {
          isPepRouteEnabled
          && (
            <Route
              element={channel === 'mobile' ? <routes.pepMobile.component /> : <routes.pep.component />}
              exact
              path={routes.pep.path}
            />
          )
        }
        <Route
          exact
          path={routes.product.path}
          element={
            channel === 'mobile'
              ? <routes.productMobile.component pipTimeout={pipTimeout} />
              : <routes.product.component pipTimeout={pipTimeout} />
          }
        />
        <Route exact path={routes.compare.path} element={<routes.compare.component />} />
        <Route exact path={routes.home.path} element={<routes.home.component />} />
        <Route path="/error" element={<Error />} />
        <Route element={<Error />} />
      </Routes>
    </>
  );
};
App.propTypes = {
  pipTimeout: string,
  prefetchPip: string,
  productPodHoverDelay: number
};
App.defaultProps = {
  pipTimeout: null,
  prefetchPip: null,
  productPodHoverDelay: 500
};
